<template>
  <div>
    <div class="header-width divcss5">
      <productdetailbanner></productdetailbanner>
    </div>
    <div class=" row body-width divcss5">
      <hlwhhjy></hlwhhjy>
    </div>
  </div>
</template>
<script>
  import productdetailbanner from "@/components//contentcoms/prodecutcontentcoms/productdetailbanner";
  import hlwhhjy from "@/components/contentcoms/prodecutcontentcoms/hlwxlcp/hlwhhjy";
  export default {
    name: "producthlwhhjy",
    components:{
      hlwhhjy,
      productdetailbanner
    }
  }

</script>



// WEBPACK FOOTER //
// src/pages/producthlwhhjy.vue